import { Dropdown } from "flowbite-react";
import { useState } from "react";
import { Popup } from "../../../components/pop-up";
import { ACL } from "../../../components/acl";
import { FINANCEADMIN, SUPERADMIN } from "../../../constants/roles";

export function ToggleUserBilling({ data, onConfirm, onLicenseConfirm, canMarkAsBase }) {
  const [openModal, setOpenModal] = useState();
  const [openLicenseModal, setOpenLicenseModal] = useState();
  const willBeBillable = !data.is_billable;
  const willBePremium = data.license_type !== "PREMIUM";
  const nextLicenseType = willBePremium ? "PREMIUM" : "BASE";
  const showLicenseToggle = willBePremium || canMarkAsBase;

  if (data.is_billable == null && data.license_type == null) {
    return null;
  }

  return (
    <ACL showFor={[FINANCEADMIN, SUPERADMIN]}>
      <Dropdown
        inline
        arrowIcon={false}
        label=""
        renderTrigger={() => (
          <span className="cursor-pointer text-gray-500 hover:text-gray-700 px-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5"
            >
              <path d="M12 6.75a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM12 13.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM12 20.25a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
            </svg>
          </span>
        )}
      >
        {data.is_billable != null && (
          <Dropdown.Item onClick={() => setOpenModal("pop-up")}>
            {willBeBillable ? "Mark as Billable" : "Mark as Non-Billable"}
          </Dropdown.Item>
        )}
        {data.license_type != null && showLicenseToggle && (
          <Dropdown.Item onClick={() => setOpenLicenseModal("pop-up")}>
            {`Mark as ${nextLicenseType}`}
          </Dropdown.Item>
        )}
      </Dropdown>
      <Popup
        content={
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to mark{" "}
            <b>{data.first_name + " " + data.last_name}</b> as{" "}
            <b className={willBeBillable ? "text-green-500" : "text-amber-500"}>
              {willBeBillable ? "Billable" : "Non-Billable"}
            </b>
            ?
          </h3>
        }
        cancelText="No, Cancel"
        confirmText={`Yes, Mark as ${willBeBillable ? "Billable" : "Non-Billable"}`}
        confirmClass={willBeBillable ? "bg-green-500 text-white" : "bg-amber-500 text-white"}
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          onConfirm && onConfirm(data, willBeBillable);
          setOpenModal(undefined);
        }}
      />
      <Popup
        content={
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to mark{" "}
            <b>{data.first_name + " " + data.last_name}</b> as{" "}
            <b className={willBePremium ? "text-green-500" : "text-gray-500"}>
              {nextLicenseType}
            </b>
            ?
          </h3>
        }
        cancelText="No, Cancel"
        confirmText={`Yes, Mark as ${nextLicenseType}`}
        confirmClass={willBePremium ? "bg-green-500 text-white" : "bg-gray-500 text-white"}
        modalState={[openLicenseModal, setOpenLicenseModal]}
        onConfirm={() => {
          onLicenseConfirm && onLicenseConfirm(data, nextLicenseType);
          setOpenLicenseModal(undefined);
        }}
      />
    </ACL>
  );
}
